/**----------------------------------------------------------------------------------------------------
 * FlightProfile control.
 *
 * Voor het ophalen van de features. Toont uiteindelijk de popup.
 *
 * European Union Public Licence V. 1.2
 * EUPL © the European Union 2007, 2016
 *
 * Modified: 2026, Eddy Scheper, ARIS BV
 */

import WFS from "ol/format/WFS";
import GeoJSON from "ol/format/GeoJSON";
import {Fill, Stroke, Style} from "ol/style";
import {Circle} from "ol/style";
import {equalTo as equalToFilter} from "ol/format/filter";
import {cloneFeatures} from "./OLUtils";
import {FlightProfilePopup} from "./FlightProfilePopup";

/**-----------------------------------------------------------------------------
 */
export default class FlightProfileControl {

  app = null;

  profilePopup = null;

  wfsOptions = null;

  /**-----------------------------------------------------------------------------
   */
  constructor(options) {

    this.app = options.app;

    // Set options source.
    options.source = options.layer.getSource();

    // Set options result src.
    options.result_src = options.result_layer.getSource();

    // Set style.
    options.style = new Style({
      fill: new Fill({
        color: "rgba(255, 0, 255, 1)"
      }),
      stroke: new Stroke({
        color: "rgba(255, 0, 255, 1)",
        lineDash: [10, 10],
        width: 2
      }),
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(255, 0, 255, 1)"
        }),
        fill: new Fill({
          color: "rgba(255, 0, 255, 0.5)"
        })
      })
    })

    // Save the initial options.
    this.options = options;

    this.profilePopup = new FlightProfilePopup(this.app);
  }
  /**-----------------------------------------------------------------------------
   * Called in: App.showFlightProfile()
   * @param url string
   * @param vlId string
   */
  getFeatures(url,vlId) {
    let self = this;

    console.log("#FlightProfileControl.getFeatures()");

    console.log("Filter vl-id: " + vlId);

    // Testing?
    if (this.app.config.TEST_USE_JSON_DATA_FILE) {
      console.log("### Using: TEST_USE_JSON_DATA_FILE");
      self.getFeaturesFile(url);
    } else {
      self.getFeaturesWfs(url,vlId);
    }
  }
  /**-----------------------------------------------------------------------------
   * Called in: getFeaturesFile()
   * @param url string
   */
  getFeaturesFile(url) {
    let self = this;
    let fullUrl;

    console.log("#FlightProfileControl.getFeaturesFile()");

    fullUrl = url + this.app.config.testFlightLineFile;

    console.log("Using url: " + fullUrl);

    fetch(fullUrl,{}).then(function(response) {
      return response.json();
    }).then(function(json) {
      self.processFeatures(json);
    }).catch(function(error) {
      console.log("### Error: "+error);
    });
  }
  /**-----------------------------------------------------------------------------
   * Called in: getFeatures()
   * @param url string
   * @param vlId string
   */
  getFeaturesWfs(url,vlId) {
    let self = this;
    let featureOptions,featureRequest,featureRequestXml,fetchOptions;
    let fieldName,fieldValue;

    console.log("#FlightProfileControl.getFeaturesWfs()");

    featureOptions = {
      srsName: "EPSG:28992",
      featureNS: "freshem",
      featurePrefix: "freshem",
      featureTypes: ["freshem:vlprofielen_v2"],
      outputFormat: "application/json",
    };

    fieldName = "vl_id";
    fieldValue = vlId;
    featureOptions.filter = equalToFilter(fieldName,fieldValue);

    featureRequest = new WFS().writeGetFeature(featureOptions);
    featureRequestXml = new XMLSerializer().serializeToString(featureRequest);

    if (self.app.config.useProfileDataProxy) {
      url = self.app.config.proxyUrl+"location/"+btoa(url);
    }

    console.log("Using url: " + url);

    fetchOptions = {
      method: "POST",
      body: featureRequestXml,
    }
    fetch(url,fetchOptions).then(function (response) {
      return response.json();
    }).then(function(json) {
      // Process the feature data.
      self.processFeatures(json);
    }).catch(function(error) {
      console.log("### Error: "+error);
    });
  }
  /**-----------------------------------------------------------------------------
   * Called in: getFeaturesFile() and getFeaturesWFS().
   * @param json object
   */
  processFeatures(json) {
    let self = this;
    let features;

    console.log("#FlightProfileControl.processFeatures()");

    // No json?
    if (!json) {
      alert("Geen data gevonden.");
      return;
    }

    // console.log("Json:");
    // console.log(json);

    // Get features.
    features = new GeoJSON().readFeatures(json);

    // No features found?
    if (!features || (features.length === 0)) {
      alert("Geen data gevonden.");
      return;
    }

    try {
      console.log("Nr. of features found: " + features.length);

      // Set geometry type.
      this.options.geomType = "FlightLine";

      // Clear results.
      this.options.result_src.clear();

      // Add found features to result_src.
      // Caution: The features order is changed when get back with getFeatures().
      this.options.result_src.addFeatures(features);

      // Clone the original features for future use with preserved order.
      this.options.wfsFeatures = cloneFeatures(features);

      // Show flightline profile.
      self.profilePopup.showPopup(this.options);
    } catch(error) {
      console.error(error);
    }
  }
}
